import { apiUrl } from '../config';
import { logger } from '../helpers/logger';

export const senddevicesIdsService = async (data) => {
  try {
    const params = new URLSearchParams();

    data.deviceIds.forEach((id) => {
      params.append('deviceIds[]', id);
    });

    params.append('start_date', data.start_date);
    params.append('end_date', data.end_date);
    params.append('type', data.type);

    const finalUrl = `${apiUrl('pdf/data-consumption/view')}?${params.toString()}`;

    window.open(finalUrl, '_blank');

    return finalUrl;
  } catch (err) {
    logger.error(err);
  }
};
